<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <InputAutocomplete @handleSelect="onSelectDriver" />
      </el-col>
      <el-col :span="6">
        <el-button
          type="primary"
          plain
          @click="$router.push({ name: 'addWithdrawal' })"
        >
          新增領款單
        </el-button>
        <el-button type="primary" plain @click="showTeamWithdrawalItem">
          預設車隊費用項目
        </el-button>
      </el-col>
    </el-row>
    <hr />
    <el-select
      v-model="npp"
      @change="onNppChange"
      style="width: 10rem; margin-bottom: 1rem; margin-right: 1%"
    >
      <el-option
        v-for="nppOption in [10, 25]"
        :key="nppOption"
        :label="nppOption"
        :value="nppOption"
      />
    </el-select>
    <span style="color: black; font-size: 1.5rem">預設顯示一年內資料</span>
    <div class="row">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize16">
            <th v-for="head in HEAD" :key="head" class="column-title">
              {{ head }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="bill in withdrawalList">
            <tr class="pointer fontSize16">
              <td
                class="click-word"
                @click="
                  editWithdrawal(
                    bill.withdrawalId,
                    bill.callNumber,
                    bill.name,
                    bill.actualWithdrawalDate,
                    bill.note,
                    bill.driverId,
                  )
                "
              >
                {{ bill.withdrawalId }}
              </td>
              <td>{{ bill.callNumber }}-{{ bill.name }}</td>
              <td>{{ bill.actualWithdrawalDate }}</td>
              <td>{{ bill.signingCount }}</td>
              <td>{{ bill.actualFee }}元</td>
              <td>{{ bill.serviceFee }}元</td>
              <td>{{ bill.actualFee + bill.serviceFee }}元</td>
              <td>
                <button
                  class="btn btn-danger"
                  @click="deleteWithdrawalConfirm(bill.withdrawalId)"
                >
                  刪除
                </button>
              </td>
              <td>
                <button
                  class="btn btn-default"
                  @click="
                    downloadWithdrawal(
                      bill.withdrawalId,
                      `${bill.callNumber}-${bill.name}`,
                    )
                  "
                >
                  下載
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <!--頁籤-->
      <el-row>
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :page-count="totalPages"
            :current-page="page"
          />
        </el-col>
      </el-row>
    </div>
    <TeamWithdrawalItemModal ref="teamWithdrawalItem" />
  </div>
</template>
<script>
import {
  reqWithdrawalList,
  reqDeleteWithdrawal,
  reqDownloadWithdrawal,
} from '@/api/withdrawal'
import { Loading, Notification, MessageBox } from 'element-ui'
import { withdrawal } from '@/constants/tableHead'
import TeamWithdrawalItemModal from './TeamWithdrawalItemModal'
import InputAutocomplete from '../element_ui/InputAutocomplete'

export default {
  components: {
    TeamWithdrawalItemModal,
    InputAutocomplete,
  },
  data() {
    return {
      driverId: null,
      withdrawalList: [],
      npp: 10,
      page: 1,
      totalPages: 1,
    }
  },
  methods: {
    onSelectDriver({ id }) {
      try {
        this.driverId = id
        this.getWithdrawalList()
      } catch (e) {
        console.error(e)
        Notification({
          message: '無此司機',
          type: 'warning',
        })
      }
    },
    onNppChange(npp) {
      this.getWithdrawalList()
    },
    onPageChange(page) {
      this.getWithdrawalList(page)
    },
    async getWithdrawalList(page = 1) {
      const loading = Loading.service()
      try {
        const {
          result: { count, list },
        } = await reqWithdrawalList(this.driverId, this.npp, page)
        this.withdrawalList = list
        this.page = page
        if (count === 0) {
          Notification({
            message: '此司機無領款單',
            type: 'warning',
          })
          this.totalPages = 1
        } else {
          this.totalPages = Math.ceil(count / this.npp)
        }
      } catch (e) {
        console.error(e)
        Notification({
          message: '發生錯誤，請稍後再試' + e,
          type: 'error',
        })
      } finally {
        loading.close()
      }
    },
    async deleteWithdrawal(id) {
      try {
        const { success, result } = await reqDeleteWithdrawal(id)
        if (success) {
          Notification({
            message: result,
            type: 'success',
          })
          this.getWithdrawalList()
        } else {
          Notification({
            message: result,
            type: 'error',
          })
          console.error(result)
        }
      } catch (e) {
        Notification({
          message: `網路連線異常`,
          type: 'error',
        })
        console.error(e)
      }
    },
    deleteWithdrawalConfirm(id) {
      MessageBox.confirm(`是否要刪除序號 ${id} 請款單？`, '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => this.deleteWithdrawal(id))
        .catch(() => {
          Notification({
            message: `取消刪除序號 ${id} 請款單`,
            type: 'info',
          })
        })
    },
    async downloadWithdrawal(id, info) {
      try {
        const res = await reqDownloadWithdrawal(id)
        const blob = new Blob([res], {
          type: 'application/octet-stream;charset=utf-8',
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = `${info}_司機領款單.xlsx`
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      } catch (e) {
        console.error(e)
      }
    },
    editWithdrawal(id, callNumber, name, actualWithdrawalDate, note, driverId) {
      this.$router.push({
        path: `editWithdrawal/${id}`,
        query: { name, callNumber, actualWithdrawalDate, note, driverId },
      })
    },
    showTeamWithdrawalItem() {
      this.$refs.teamWithdrawalItem.showModal()
    },
  },
  created() {
    this.HEAD = withdrawal
  },
}
</script>
<style scoped>
.click-word {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/company/WithdrawalList.vue